import hoistNonReactStatics from 'hoist-non-react-statics';
import createHoc from './createHoc';
/**
 * Global index counter to preserve source order.
 * As we create the style sheet during componentWillMount lifecycle,
 * children are handled after the parents, so the order of style elements would
 * be parent->child. It is a problem though when a parent passes a className
 * which needs to override any childs styles. StyleSheet of the child has a higher
 * specificity, because of the source order.
 * So our solution is to render sheets them in the reverse order child->sheet, so
 * that parent has a higher specificity.
 *
 * @type {Number}
 */

var indexCounter = -100000;
var NoRenderer = function NoRenderer(_ref) {
  var children = _ref.children;
  return children || null;
};
NoRenderer.styleRoot = 'NoRenderer';
/**
  * HOC creator function that wrapps the user component.
  *
  * `injectStyles(styles, [options])(Component)`
  *
  * Options:
  * https://github.com/cssinjs/jss/blob/master/src/types/jss.js#L130
  *
  * @param  {Object|Function} stylesOrSheet -
  * @param  {Object} [options = {}] -
  * @return {Function} -
*/

export default function injectStyles(stylesOrSheet) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (options.index === undefined) {
    options.index = indexCounter++; // eslint-disable-line no-param-reassign
  }
  if (options.includeQaClassNames === undefined) {
    options.includeQaClassNames = false; // eslint-disable-line no-param-reassign
  }
  return function () {
    var InnerComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NoRenderer;
    var Jss = createHoc(stylesOrSheet, InnerComponent, options);
    return hoistNonReactStatics(Jss, InnerComponent, {
      inner: true
    });
  };
}